import Typography from "@mui/material/Typography"

export default function RenderedEmailBody({ renderedBody, sx = {} }) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      whiteSpace="pre-wrap"
      sx={{
        mt: 1,
        maxHeight: "10em",
        overflowY: "auto",
        "& *": { marginBlock: 0 },
        "& img": { maxWidth: "100%", height: "auto" },
        ...sx,
      }}
      dangerouslySetInnerHTML={{
        __html: renderedBody,
      }}
    />
  )
}
